import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/styled-system';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers([
  'container',
  'track',
  'thumb',
  'filledTrack',
]);

const baseStyleContainer = defineStyle(() => ({
  _disabled: {
    cursor: 'default',
    opacity: 0.6,
    pointerEvents: 'none',
  },
  cursor: 'pointer',
  display: 'inline-block',
  position: 'relative',
  width: '100%',
}));

const baseStyleTrack = defineStyle(() => ({
  backgroundColor: 'neutral.95',
  borderRadius: '4',
  height: '8',
  overflow: 'hidden',
}));

const baseStyleThumb = defineStyle(() => ({
  _active: {
    transform: 'translateY(-50%) scale(1.15)',
  },
  _focusVisible: {
    boxShadow: 'outline',
  },
  alignItems: 'center',
  bg: 'neutral.100',
  border: '1px solid',
  borderColor: 'neutral.90',
  borderRadius: '4',
  color: 'neutral.90',
  display: 'flex',
  height: '40px',
  justifyContent: 'center',
  outline: 0,
  position: 'absolute',
  top: '50%',
  transform: `translateY(-50%)`,
  transitionProperty: 'transform',
  width: '40px',
  zIndex: 1,
}));

const baseStyleFilledTrack = defineStyle(() => ({
  backgroundColor: 'purple.40',
  borderRadius: 'inherit',
  height: 'inherit',
  width: 'inherit',
}));

const baseStyle = definePartsStyle(() => ({
  container: baseStyleContainer(),
  filledTrack: baseStyleFilledTrack(),
  thumb: baseStyleThumb(),
  track: baseStyleTrack(),
}));

const SliderTheme = defineMultiStyleConfig({ baseStyle });

export default SliderTheme;
